export default __webpack_public_path__ + "static/media/wegovy-remove-needle.217c1f77.mp4";